import { useEffect, useState, useCallback } from "react"
import AdminOrderCard from "./Orders/AP_OrderCard"
import AdminOrderModals from "./Orders/AP_OrderModal"

function AdminOrdersPanel() {
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  /* =========================
     MODAL STATE
  ========================= */

  const [selectedOrder, setSelectedOrder] = useState(null)
  const [modalMode, setModalMode] = useState(null) // "view" | "update"

  /* =========================
     FETCH ORDERS
  ========================= */

  const getOrders = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)

      const res = await fetch(`${process.env.REACT_APP_API_URL}/orders`, {
        credentials: "include",
      })

      if (!res.ok) throw new Error("Failed to fetch orders")

      const data = await res.json()

      const orderList = Array.isArray(data) ? data : data.orders || []

      const filtered = orderList
        .filter((o) => o && o.user_orders?.length > 0)
        .map((o) => ({
          ...o,
          product_image:
            o.product_image || o.product?.image || "/placeholder.png",
        }))

      setOrders(filtered)
    } catch (err) {
      console.error("❌ Orders load error:", err)
      setError("Failed to load orders")
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getOrders()
  }, [getOrders])

  /* =========================
     ACTION HANDLERS
  ========================= */

  const handleView = (order) => {
    setSelectedOrder(order)
    setModalMode("view")
  }

  const handleUpdate = (order) => {
    setSelectedOrder(order)
    setModalMode("update")
  }

  const handleCloseModal = () => {
    setSelectedOrder(null)
    setModalMode(null)
  }

  const handleUpdated = () => {
    getOrders() // refresh after update
  }

  /* =========================
     STATES
  ========================= */

  if (loading) {
    return <div className="text-center py-5">Loading orders...</div>
  }

  if (error) {
    return <div className="text-center py-5 text-danger">{error}</div>
  }

  if (!orders.length) {
    return <div className="text-center py-5">No active orders</div>
  }

  /* =========================
     RENDER
  ========================= */

  return (
    <div className="container py-4">
      <h3 className="text-center mb-4">Orders</h3>

      <div className="row justify-content-center">
        {orders.map((order) => (
          <AdminOrderCard
            key={order._id}
            order={order}
            onView={handleView}
            onUpdate={handleUpdate}
          />
        ))}
      </div>

      {/* =========================
         MODAL RENDER
      ========================= */}
      {selectedOrder && (
        <AdminOrderModals
          selectedOrder={selectedOrder}
          mode={modalMode}
          onClose={handleCloseModal}
          onUpdated={handleUpdated}
        />
      )}
    </div>
  )
}

export default AdminOrdersPanel
